import Modifier from 'ember-modifier';
import Color from 'colorjs.io'
import extractStyleParams from '../utils/extract-style-params';

export default class ThemeColors extends Modifier {
  element = null;
  containerElement = null;

  buildColorsFromBackground(color) {
    let style = {}
    try {
      style['background-color'] = new Color(color).toString({format: 'hex'});
      style['background-color-dark'] = new Color(color).set({
        'oklch.l': l => l * 0.95
      }).toString({format: 'hex'})
  
      style['background-color-light'] = new Color(color).set({
        'oklch.l': l => l * 1.05
      }).toString({format: 'hex'})
  
      style['background-gradient-color-1'] = new Color(color).set({
        'oklch.h': h => h - 15
      }).toString({format: 'hex'})
      style['background-gradient-color-2'] = new Color(color).toString({format: 'hex'})
      style['background-gradient-color-3'] = new Color(color).set({
        'oklch.h': h => h + 15
      }).toString({format: 'hex'})
    } catch(e) {
      console.error(`error building background colors for ${color}`)
      console.error(e)
    } finally {
      // console.log(`built background colors from ${color}`, style)
      return style
    }
  }

  buildColorsFromText(color) {
    let style = {}

    try {
      style['text-color'] = new Color(color).toString({format: 'hex'});
      style['text-color-muted'] = new Color(color).set({'oklch.l': (l) => l * 1.1 }).toString({format: 'hex'});
    } catch(e) {
      console.error(`error building text colors for ${color}`)
      console.error(e)
    } finally {
      // console.log(`built text colors from ${color}`, style)
      return style
    }
  }

  buildColorsFromHighlight(color) {
    let style = {}
    try {
      style['highlight-color'] = new Color(color).toString({format: 'hex'});
      style['highlight-color-dark'] = new Color(color).set({
        'oklch.l': l => l * 1.2
      }).toString({format: 'hex'})
      style['highlight-color-light'] = new Color(color).set({
        'oklch.l': l => l * 0.8
      }).toString({format: 'hex'})
      return style;
    } catch(e) {
      console.error(`error building highlight colors for ${color}`)
      console.error(e)
    } finally {
      return style
    }

  }

  buildContrastingTextColorFromBackground(color) {
    try {
      let bg = new Color(color)
      let text1 = new Color(color).set("hsl.l", l => 95)
      let text2 = new Color(color).set("hsl.l", l => 5)

      if (bg.contrast(text1, "WCAG21") > bg.contrast(text2, "WCAG21")) {
        return text1
      } else {
        return text2
      }
    }
    catch(e) {
      console.error(e)
    }
  }


  get calculatedStyle() {
    let style = {};
    let backgroundColors = {}, textColors = {}, highlightColors = {}
    try {
      let customStyle = extractStyleParams(this.containerElement);
      // console.log('specified style params', customStyle)
      backgroundColors = this.buildColorsFromBackground(customStyle['background-color'] || "#333")

      if (customStyle['text-color']) {
        textColors = this.buildColorsFromText(customStyle['text-color'])
      } else {
        let defaultTextColor = this.buildContrastingTextColorFromBackground(backgroundColors['background-color'])
        textColors = this.buildColorsFromText(defaultTextColor.toString())
      }

      highlightColors = this.buildColorsFromHighlight(customStyle['highlight-color'] || textColors['text-color'])

      style = {...backgroundColors, ...highlightColors, ...textColors }
    } catch (e) {
      console.error(e);
    }

    return style;
  }

  convertVariables() {
    Object.keys(this.calculatedStyle).forEach((key) => {
      this.element.style.setProperty(
        `--dt-${key}`,
        `${this.calculatedStyle[key]}`
      );
    });
  }

  modify(element, positionalArgs, { containerElementId }) {
    this.element = element;
    this.containerElement = containerElementId
      ? document.getElementById(containerElementId)
      : element;

    let MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver;

    this.observer = new MutationObserver(() => this.convertVariables());
    this.observer.observe(this.containerElement, {
      attributes: true,
    });
    this.convertVariables();

    return () => {
      this.observer.disconnect();
    };
  }
}
